import { gql } from "@apollo/client/core";

export const REQUEST_MAGIC_LINK = gql`
  mutation RequestMagicLink($input: RequestMagicLinkInput!) {
    requestMagicLink(input: $input) {
      success
      message
      errorCode
    }
  }
`;

export const VERIFY_MAGIC_LINK = gql`
  mutation VerifyMagicLink($input: VerifyMagicLinkInput!) {
    verifyMagicLink(input: $input) {
      accessToken
      refreshToken
      tokenType
      expiresIn
      user {
        id
        email
        name
        onboardingCompletedAt
      }
    }
  }
`;

export const GET_OAUTH_URL = gql`
  mutation GetOauthUrl($input: GetOauthUrlInput!) {
    getOauthUrl(input: $input) {
      authorizationUrl
      state
    }
  }
`;

export const EXCHANGE_OAUTH_CODE = gql`
  mutation ExchangeOauthCode($input: ExchangeOauthCodeInput!) {
    exchangeOauthCode(input: $input) {
      accessToken
      refreshToken
      tokenType
      expiresIn
      user {
        id
        email
        name
        onboardingCompletedAt
      }
    }
  }
`;
